import { useMemo } from 'react';

import { MarkerPresetType } from 'services/audio.service';
import { useAppSelector } from 'store/store-hooks';
import { useMarkersReset } from 'components/app/editor/_mediator/editor-markers/use-markers-reset';

import { ReactComponent as ResetIcon } from 'assets/wavesurfer/reset.svg';
import { Option } from 'components/UI/select/select';
import { WsSelect } from './elements/ws-select';
import { WsButton } from './elements/ws-button';
import styles from './_ws-header.module.scss';

export const WsHeaderMarkersReset = () => {
  const selectedStory = useAppSelector((state) => state.projects.selectedStory);
  const markerPresets = useAppSelector((state) => state.editor.markerPresets);
  const selectedMarkerPreset = useAppSelector((state) => state.editor.selectedMarkerPreset);
  const resetMarkers = useMarkersReset();

  const options: Option[] = useMemo(() => {
    return markerPresets.map((preset) => ({ label: MarkerPresetType[preset.type], value: preset.id }));
  }, [markerPresets]);

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = +e.target.value;
    handleReset(id);
  };

  const handleReset = (markerPresetId: MarkerPresetId | null) => {
    if (!selectedStory || !markerPresetId) return;
    resetMarkers(markerPresetId);
  };

  return (
    <div className={styles.WsHeader__reset}>
      <WsButton onClick={() => handleReset(selectedMarkerPreset)} tip="Reset beat markers">
        <ResetIcon />
      </WsButton>
      <WsSelect
        className={styles.WsHeader__resetSelect}
        value={selectedMarkerPreset ?? undefined}
        options={options}
        onChange={onChange}
        disabledOptions={true}
        tip="Select beat marker preset"
      />
    </div>
  );
};
